// extracted by mini-css-extract-plugin
export default {"root":"IconChevronRight_root__-lS02"};